import React from "react";
import { connect } from "react-redux";

import {
  mapStateToProps,
  mapDispatchToProps,
  TourContainer
} from "components/shared/Tour/TourContainer";

import TourPage from "./TourPage";

export class GourmetGrammarTourContainer extends TourContainer {
  render() {
    return (
      <TourPage
        projectId={this.props.projectId}
        redirectUrl={this.state.redirectUrl}
        completedTour={this.state.completedTour}
        slidesLength={this.state.slidesLength}
        handleCloseClick={this.handleCloseClick}
        setSlidesLength={this.setSlidesLength}
        setCompletedTour={this.setCompletedTour}
        language={this.props.language}
      />
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GourmetGrammarTourContainer);
